<template>
  <main class="card-atm-page">
    <AppNavBar :title="pageTitle" backgroundColor="#fff" />

    <section class="form-card">
      <div class="form-card-label pt-0">{{ t("card.atmPassword") }}</div>
      <div class="atm-field-shell">
        <van-field
          class="form-card_input"
          v-model="pin"
          :type="showPin ? 'text' : 'password'"
          clearable
          :readonly="isViewMode"
          :placeholder="t('card.enterAtmPassword')"
        >
          <template #button>
            <!-- <van-icon :name="showPin ? 'eye-o' : 'closed-eye'" @click="showPin = !showPin" /> -->
            <button
              type="button"
              class="auth-eye-btn"
              @click="showPin = !showPin"
            >
              <app-image :src="showPin ? eyeOpenIcon : eyeCloseIcon" alt="" />
            </button>
          </template>
        </van-field>
      </div>
      <div class="form-card-label" v-if="!isViewMode">
        {{ t("card.confirmAtmPassword") }}
      </div>
      <div v-if="!isViewMode" class="atm-field-shell">
        <van-field
          class="form-card_input"
          v-model="confirmPin"
          :type="showConfirmPin ? 'text' : 'password'"
          clearable
          :placeholder="t('card.confirmAtmPassword')"
        >
          <template #button>
            <!-- <van-icon :name="showConfirmPin ? 'eye-o' : 'closed-eye'" @click="showConfirmPin = !showConfirmPin" /> -->
            <button
              type="button"
              class="auth-eye-btn"
              @click="showConfirmPin = !showConfirmPin"
            >
              <app-image
                :src="showConfirmPin ? eyeOpenIcon : eyeCloseIcon"
                alt=""
              />
            </button>
          </template>
        </van-field>
      </div>
    </section>

    <van-button
      v-if="!isViewMode"
      block
      round
      type="primary"
      class="submit-btn"
      @click="submitPin"
    >
      {{ t("common.confirm") }}
    </van-button>
  </main>
</template>

<script setup>
import { computed, ref } from "vue";
import { showFailToast, showLoadingToast, closeToast, showToast } from "vant";
import { showPassedToast } from "@/utils/toast";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { pcCardUpdatePIN } from "@/api/card";
import { useProfileStore } from "@/stores/profile";
import { getRouteState } from "@/utils/route-state";
import eyeOpenIcon from "@/assets/images/eye_open_icon.png";
import eyeCloseIcon from "@/assets/images/eye_close_icon.png";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const profileStore = useProfileStore();
const pageState = computed(() => getRouteState(route, "card-atm", {}));
const routePin = String(
  pageState.value?.pin || window.history.state?.pin || "",
);

const pin = ref(routePin);
const confirmPin = ref("");
const showPin = ref(false);
const showConfirmPin = ref(false);

const isViewMode = computed(() => !!routePin.trim());
const pageTitle = computed(() =>
  isViewMode.value ? t("card.viewAtmPassword") : t("card.atmPassword"),
);

function isValidPin(value) {
  return /^\d{6}$/.test(String(value || ""));
}

async function submitPin() {
  if (!profileStore.platformAddress || !pageState.value.cardId) {
    router.replace("/home/card");
    return;
  }
  if (!isValidPin(pin.value)) {
    showFailToast(t("card.sixDigitPin"));
    return;
  }
  if (pin.value !== confirmPin.value) {
    showFailToast(t("auth.passwordMismatch"));
    return;
  }

  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });
  try {
    await pcCardUpdatePIN({
      address: profileStore.platformAddress,
      cardId: pageState.value.cardId,
      pin: pin.value,
    });
    closeToast();
    showPassedToast(t("card.setPinSuccess"));
    router.back();
  } catch (error) {
    closeToast();
  }
}
</script>

<style scoped lang="scss">
.card-atm-page {
  min-height: var(--app-viewport-height);
  padding: 15px 14px 34px;
  background: #ffffff;
}

.form-card {
  .form-card-label {
    font-size: 17px;
    background: #fff;
    padding-bottom: 10px;
    padding-top: 20px;
  }

  .form-card_input {
    border-radius: 12px;
  }

  .pt-0 {
    padding-top: 0;
  }
}

.atm-tip {
  margin: 12px 0 0;
  color: #ef0027;
  font-size: 12px;
  line-height: 18px;
}

.submit-btn {
  margin-top: 20px;
}
.auth-eye-btn {
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;

  .app-image {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
}
</style>
